import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PreviewBanner({ title, kind }) {
  return (
    <div className="fixed bottom-6 left-6 z-40 bg-[#0A0A0A] border border-[#333] pl-3 pr-4 py-2 flex items-center gap-3 shadow-2xl">
      <Link to="/preview" className="text-[#EAEAEA] hover:text-[#7C3AED] flex items-center gap-2" data-testid="preview-back">
        <ArrowLeft size={14} />
        <span className="overline">All variants</span>
      </Link>
      <span className="text-[#333]">·</span>
      <span className="overline text-[#888]">{kind}</span>
      <span className="text-[#333]">·</span>
      <span className="overline text-[#EAEAEA]">{title}</span>
    </div>
  );
}
